import { render, staticRenderFns } from "./PassportLogin.vue?vue&type=template&id=f1ed56be&scoped=true&"
import script from "./PassportLogin.vue?vue&type=script&lang=js&"
export * from "./PassportLogin.vue?vue&type=script&lang=js&"
import style0 from "./PassportLogin.vue?vue&type=style&index=0&id=f1ed56be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ed56be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
